export default __webpack_public_path__ + "static/harmons-6e484da15bd619671e9bdfe296244422.jpg";